/**
 * Navigation Overlay
 * Creates a shadow overlay with blur effect when navigation or search is active
 */

let overlay = null;

const createOverlay = () => {
	if (!overlay) {
		overlay = document.createElement('div');
		overlay.className = 'navigation-overlay';
		overlay.setAttribute('aria-hidden', 'true');
		document.body.appendChild(overlay);
	}
	return overlay;
};

const showOverlay = () => {
	const overlayElement = createOverlay();
	overlayElement.classList.add('active');
	document.body.classList.add('navigation-overlay-active');
};

const hideOverlay = () => {
	if (overlay) {
		overlay.classList.remove('active');
		document.body.classList.remove('navigation-overlay-active');
	}
};

const checkNavigationState = () => {
	const hasActiveNav = document.querySelector('.block-navigation.active');
	const hasActiveSearch = document.querySelector(
		'.block-navigation.search-active'
	);

	if (hasActiveNav || hasActiveSearch) {
		showOverlay();
	} else {
		hideOverlay();
	}
};

const init = () => {
	// Listen for navigation events
	window.addEventListener('navigation-opened', showOverlay);
	window.addEventListener('navigation-closed', hideOverlay);
	window.addEventListener('navigation-search-opened', showOverlay);
	window.addEventListener('navigation-search-closed', hideOverlay);

	// Check initial state
	checkNavigationState();

	// Use MutationObserver as fallback to detect class changes
	const navigationBlocks = document.querySelectorAll('.block-navigation');
	if (navigationBlocks.length > 0) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (
					mutation.type === 'attributes' &&
					mutation.attributeName === 'class'
				) {
					checkNavigationState();
				}
			});
		});

		navigationBlocks.forEach((block) => {
			observer.observe(block, {
				attributes: true,
				attributeFilter: ['class'],
			});
		});
	}

	// Handle overlay clicks to close menu
	if (overlay) {
		overlay.addEventListener('click', () => {
			// Trigger close events
			const closeNavEvent = new Event('click');
			closeNavEvent.target = overlay;
			document.dispatchEvent(closeNavEvent);
		});
	}
};

export default {
	init,
	showOverlay,
	hideOverlay,
	checkNavigationState,
};
